import { render, staticRenderFns } from "./dialog-ocr.vue?vue&type=template&id=dab4990c"
import script from "./dialog-ocr.vue?vue&type=script&setup=true&lang=js"
export * from "./dialog-ocr.vue?vue&type=script&setup=true&lang=js"
import style0 from "./dialog-ocr.vue?vue&type=style&index=0&id=dab4990c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports